<template>
    <div>

        <b-form-group>
            <label for="input-adresse-etranger"><strong>Adresse de résidence à l'étranger*</strong></label>
            <b-form-input
                id="input-adresse-etranger"
                v-model="adresseEtranger"
                debounce="800"
                :state="adresseEtrangerState"
                @keydown="tappingAdresseEtranger"
                @focus="focusingAdresseEtranger"
                @blur="bluringAdresseEtranger"
                maxlength="300"
                trim
            ></b-form-input>
            <MenuListe
                ref="menuListe"
                :liste="adressesEtranger"
                @clickOnMenuListe="setAdresseEtranger($event); selectedPaysResidence($event)"/>

            <b-form-invalid-feedback :state="adresseEtrangerState">
                Veuillez renseigner votre adresse de résidence à l'étranger
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
            <label for="select-pays-residence"><strong>Pays de résidence à l'étranger*</strong></label>
            <b-form-select
                id="select-pays-residence"
                v-model="paysResidence"
                :options="listePaysResidence"
                :state="paysResidenceState"></b-form-select>

            <b-form-invalid-feedback :state="paysResidenceState">
                Veuillez sélectionner le pays de résidence dans la liste
            </b-form-invalid-feedback>

            <b-alert show v-if="paysResidenceState && !isCnarefeEligible()" variant="danger" class="mt-3 mb-0">
                <b-row align-v="center">
                    <b-col cols="auto">
                        <b-icon icon="x-circle" scale="1.5"></b-icon>
                    </b-col>
                    <b-col>
                        <h5>Ce pays ne fait pas parti de la zone gerée par nos services</h5>
                        Si vous résidez dans un pays de l'UE/EEE, en Suisse, au Royaume-Uni, ou à Monaco, vous ne pouvez pas bénéficier de l'affiliation au CNAREFE.
                    </b-col>
                </b-row>
            </b-alert>

            <b-alert show v-else-if="paysResidence.nomPays && (paysResidence.nomPays != paysEtranger)" variant="warning" class="mt-3 mb-0">
                <b-row align-v="center">
                    <b-col cols="auto">
                        <b-icon icon="info-circle" scale="1.5"></b-icon>
                    </b-col>
                    <b-col>
                        <h5>Le pays semble être différent de celui indiqué dans l'adresse</h5>
                        Vous avez peut être saisi une adresse incomplète ou en dehors des choix proposés. Dans tous les cas, pour un traitement optimal de votre dossier, assurez-vous que le pays de résidence choisi correspond bien à l'adresse.
                    </b-col>
                </b-row>
            </b-alert>
        </b-form-group>

        <!-- Pays de résidence CANADA -->
        <div v-if="paysResidence.codePays == 'CA'">
            <!-- Province QUEBEC ou AUTRE -->
            <b-form-group>
                <label for="select-province-canada"><strong>Province*</strong></label>
                <b-form-select
                    id="select-province-canada"
                    v-model="provinceCanada"
                    :options="listeProvincesCanada"
                    :state="provinceCanadaState">
                </b-form-select>
            </b-form-group>

            <QuinzeAnneesCotisations
                :show="provinceCanada == 'autre' || $store.nationalite != 'FR'"/>

            <!-- QUEBEC et nationalité française -->
            <div v-if="provinceCanada == 'quebec' && $store.nationalite == 'FR'">
                <b-form-group>
                    <label for="select-nationalite-francaise-canadienne"><strong>Êtes-vous de nationalité...*</strong></label>
                    <b-form-select
                        id="select-nationalite-francaise-canadienne"
                        v-model="nationaliteFrCa"
                        :options="listeNationaliteFrCa"
                        :state="nationaliteFrCaState">
                    </b-form-select>

                    <b-form-invalid-feedback :state="nationaliteFrCaState">
                        Veuillez indiquer si vous bénéficiez ou pas d'une double nationalité
                    </b-form-invalid-feedback>
                </b-form-group>

                <!-- Nationalité française uniquement -->
                <AlerteInfoNonSoumis15AnneesCotisations
                    :show="nationaliteFrCa == 'fr'"
                    casParticuliers="0"/>

                <!-- Double nationalité : française et canadienne -->
                <QuinzeAnneesCotisations
                    :show="nationaliteFrCa == 'fr-ca'"/>
            </div>
        </div>

        <!-- pays conventionnés : Bosnie-Herzégovine (BA), Monténégro (ME), Maroc (MA), Tunisie (TN), Kosovo (XK), Macédoine (MK) -->
        <div v-else-if="paysResidence.codePays == 'BA' || paysResidence.codePays == 'ME' || paysResidence.codePays == 'MA' || paysResidence.codePays == 'TN' || paysResidence.codePays == 'XK' || paysResidence.codePays == 'MK'">
            <b-form-group>
                <label for="select-pension-retraite-multi-origines"><strong>Vous percevez une pension de retraite...</strong></label>
                <b-form-select
                    id="select-pension-retraite-multi-origines"
                    v-model="pensionMultiOrigines"
                    :options="listePensionMultiOrigines"
                    :state="pensionMultiOriginesState">
                </b-form-select>

                <b-form-invalid-feedback :state="pensionMultiOriginesState">
                    Veuillez indiquer si vous bénéficiez ou pas d'une pension de retraite multi-origines
                </b-form-invalid-feedback>
            </b-form-group>

            <AlerteInfoNonSoumis15AnneesCotisations
                :show="pensionMultiOrigines == 0"
                casParticuliers="1"/>

            <QuinzeAnneesCotisations
                :show="pensionMultiOrigines == 1"/>
        </div>

        <!-- pays conventionnés : Polynésie française (PF), Saint-Pierre et Miquelon (PM), Andorre (AD), Serbie (RS) -->
        <div v-else-if="paysResidence.codePays == 'PF' || paysResidence.codePays == 'PM' || paysResidence.codePays == 'AD' || paysResidence.codePays == 'RS'">
            <b-form-group>
                <label for="select-pension-retraite-multi-origines"><strong>Vous percevez une pension de retraite...</strong></label>
                <b-form-select
                    id="select-pension-retraite-multi-origines"
                    v-model="pensionMultiOrigines"
                    :options="listePensionMultiOrigines"
                    :state="pensionMultiOriginesState">
                </b-form-select>

                <b-form-invalid-feedback :state="pensionMultiOriginesState">
                    Veuillez indiquer si vous bénéficiez ou pas d'une pension de retraite multi-origines
                </b-form-invalid-feedback>
            </b-form-group>

            <AlerteInfoNonSoumis15AnneesCotisations
                :show="pensionMultiOrigines == 0"
                casParticuliers="0"/>

            <b-alert show v-if="pensionMultiOrigines == 1" variant="danger" class="mt-3">
                <b-row align-v="center">
                    <b-col cols="auto">
                        <b-icon icon="x-circle" scale="1.5"></b-icon>
                    </b-col>
                    <b-col>
                        <h5>Pensions de retraite d'origines multiples</h5>
                        Si vous percevez une pension de retraite française et que vous percevez une pension de retraite de votre pays de résidence, l'Assurance Maladie en France n'est pas compétente pour la prise en charge de vos soins.
                    </b-col>
                </b-row>
            </b-alert>
        </div>

        <!-- pays conventionnés : Nouvelle-Calédonie (NC) -->
        <div v-else-if="paysResidence.codePays == 'NC'">
            <AlerteInfoNonSoumis15AnneesCotisations
                :show="1"
                casParticuliers="0"/>
        </div>

        <!-- pour tous les autres pays égilibles au CNAREFE ... -->
        <div v-else-if="isCnarefeEligible() && paysResidenceState">
            <QuinzeAnneesCotisations
                :show="1"/>
        </div>

        <div v-if="checkFirst">
            <b-form-group class="mt-5">
                <label for="input-email"><strong>Email*</strong></label>
                <b-form-input
                    id="input-email"
                    v-model="email"
                    :state="emailState"
                    lazy-formatter
                    :formatter="upperCase"
                    maxlength="100"
                    trim
                ></b-form-input>

                <b-form-invalid-feedback :state="emailState">
                    Veuillez renseigner une adresse email valide
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group>
                <b-form-checkbox
                    v-model="adresseTempoFrance"
                    switch
                    value="1"
                    unchecked-value="0">
                    Je souhaite utiliser temporairement une adresse postale en France pour recevoir mes correspondances
                </b-form-checkbox>
            </b-form-group>

            <div v-if="adresseTempoFrance == 1">

                <b-alert show variant="info">
                    <b-row align-v="center">
                        <b-col cols="auto">
                            <b-icon icon="info-circle" scale="1.5"></b-icon>
                        </b-col>
                        <b-col>
                            En cas de difficulté d'acheminement du courrier dans mon pays de résidence, je peux utiliser exceptionnellement une adresse postale en France pour une durée de 6 mois maximum.
                        </b-col>
                    </b-row>
                </b-alert>

                <b-form-group>
                    <label for="input-nom-hote-adresse-en-france">Chez M. ou Mme</label>
                    <b-form-input
                        id="input-nom-hote-adresse-en-france"
                        v-model="nomHoteAdresseFrance"
                        lazy-formatter
                        :state="nomHoteAdresseFranceState"
                        :formatter="upperCase"
                        maxlength="50"
                        trim
                    ></b-form-input>

                    <b-form-invalid-feedback :state="nomHoteAdresseFranceState">
                        Le nom que vous avez saisi ne semble pas valide
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group>
                    <label for="input-adresse-en-france"><strong>Adresse en France*</strong></label>
                    <b-form-input
                        id="input-adresse-en-france"
                        v-model="adresseFrance"
                        debounce="800"
                        :state="adresseFranceState"
                        @keydown="tappingAdresseFrance"
                        @focus="focusingAdresseFrance"
                        @blur="bluringAdresseFrance"
                        maxlength="300"
                        trim
                    ></b-form-input>
                    <MenuListe
                        ref="menuListe1"
                        :liste="adressesFrance"
                        @clickOnMenuListe="setAdresseFrance"/>

                    <b-form-invalid-feedback :state="adresseFranceState">
                        Veuillez renseigner une adresse postale en France
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group>
                    <label for="input-commune-en-france"><strong>Commune*</strong></label>
                    <b-form-input
                        id="input-commune-en-france"
                        v-model="communeFrance"
                        debounce="800"
                        :state="communeFranceState"
                        @keydown="tappingCommuneFrance"
                        @focus="focusingCommuneFrance"
                        @blur="bluringCommuneFrance"
                        maxlength="200"
                        placeholder="Entrez le nom d'une commune ou son CP"
                        trim
                    ></b-form-input>
                    <MenuListe
                        ref="menuListe2"
                        :liste="communesFrance"
                        @clickOnMenuListe="setCommuneFrance"/>

                    <b-form-invalid-feedback :state="communeFranceState">
                        Veuillez renseigner une commune en France
                    </b-form-invalid-feedback>
                </b-form-group>

            </div>
        </div>

        <BackNext
            :buttons="buttons"/>

    </div>
</template>

<script>
import MenuListe from '@/components/MenuListe'
import QuinzeAnneesCotisations from '@/components/QuinzeAnneesCotisations'
import AlerteInfoNonSoumis15AnneesCotisations from '@/components/AlerteInfoNonSoumis15AnneesCotisations'
import BackNext from '@/components/BackNext'

export default {
  name: 'Coordonnees',
  components: {
    MenuListe,
    QuinzeAnneesCotisations,
    AlerteInfoNonSoumis15AnneesCotisations,
    BackNext
  },
  data() {
    return {
        listeProvincesCanada: [
            { text: 'Veuillez choisir...', value: null },
            { text: 'Québec', value: 'quebec' },
            { text: 'Autres provinces', value: 'autre' }
        ],
        listeNationaliteFrCa: [
            { text: 'Veuillez choisir...', value: null },
            { text: 'Française uniquement', value: 'fr' },
            { text: 'Française et Canadienne', value: 'fr-ca' }
        ],
        listePensionMultiOrigines: [
            { text: 'Veuillez choisir...', value: null },
            { text: 'De la sécurité sociale française uniquement', value: 0 },
            { text: 'De la sécurité sociale française + une pension de mon pays de résidence', value: 1 }
        ],
    }
  },
  computed: {
        adresseEtranger: {
            get() {
                return this.$store.adresseEtranger
            },
            set(val) {
                this.$store.adresseEtranger = val
            }
        },
        adresseEtrangerState: {
            get() {
                return this.$store.adresseEtrangerState
            },
            set(val) {
                this.$store.adresseEtrangerState = val
            }
        },
        paysEtranger: {
            get() {
                return this.$store.paysEtranger
            },
            set(val) {
                this.$store.paysEtranger = val
            }
        },
        adressesEtranger: {
            get() {
                return this.$store.adressesEtranger
            },
            set(val) {
                this.$store.adressesEtranger = val
            }
        },
        paysResidence: {
            get() {
                return this.$store.paysResidence
            },
            set(val) {
                this.$store.paysResidence = val
            }
        },
        paysResidenceState: {
            get() {
                return this.$store.paysResidenceState
            },
            set(val) {
                this.$store.paysResidenceState = val
            }
        },
        listePaysResidence: {
            get() {
                return this.$store.listePaysResidence
            },
            set(val) {
                this.$store.listePaysResidence = val
            }
        },
        provinceCanada: {
            get() {
                return this.$store.provinceCanada
            },
            set(val) {
                this.$store.provinceCanada = val
            }
        },
        provinceCanadaState: {
            get() {
                return this.$store.provinceCanadaState
            },
            set(val) {
                this.$store.provinceCanadaState = val
            }
        },
        nationaliteFrCa: {
            get() {
                return this.$store.nationaliteFrCa
            },
            set(val) {
                this.$store.nationaliteFrCa = val
            }
        },
        nationaliteFrCaState: {
            get() {
                return this.$store.nationaliteFrCaState
            },
            set(val) {
                this.$store.nationaliteFrCaState = val
            }
        },
        pensionMultiOrigines: {
            get() {
                return this.$store.pensionMultiOrigines
            },
            set(val) {
                this.$store.pensionMultiOrigines = val
            }
        },
        pensionMultiOriginesState: {
            get() {
                return this.$store.pensionMultiOriginesState
            },
            set(val) {
                this.$store.pensionMultiOriginesState = val
            }
        },
        email: {
            get() {
                return this.$store.email
            },
            set(val) {
                this.$store.email = val
            }
        },
        emailState: {
            get() {
                return this.$store.emailState
            },
            set(val) {
                this.$store.emailState = val
            }
        },
        adresseTempoFrance: {
            get() {
                return this.$store.adresseTempoFrance
            },
            set(val) {
                this.$store.adresseTempoFrance = val
            }
        },
        nomHoteAdresseFrance: {
            get() {
                return this.$store.nomHoteAdresseFrance
            },
            set(val) {
                this.$store.nomHoteAdresseFrance = val
            }
        },
        nomHoteAdresseFranceState: {
            get() {
                return this.$store.nomHoteAdresseFranceState
            },
            set(val) {
                this.$store.nomHoteAdresseFranceState = val
            }
        },
        adresseFrance: {
            get() {
                return this.$store.adresseFrance
            },
            set(val) {
                this.$store.adresseFrance = val
            }
        },
        adresseFranceState: {
            get() {
                return this.$store.adresseFranceState
            },
            set(val) {
                this.$store.adresseFranceState = val
            }
        },
        adressesFrance: {
            get() {
                return this.$store.adressesFrance
            },
            set(val) {
                this.$store.adressesFrance = val
            }
        },
        communeFrance: {
            get() {
                return this.$store.communeFrance
            },
            set(val) {
                this.$store.communeFrance = val
            }
        },
        communeFranceState: {
            get() {
                return this.$store.communeFranceState
            },
            set(val) {
                this.$store.communeFranceState = val
            }
        },
        communesFrance: {
            get() {
                return this.$store.communesFrance
            },
            set(val) {
                this.$store.communesFrance = val
            }
        },

        // Lance le controle des données sur la première partie du formulaire
        checkFirst: function() {
            return (this.adresseEtrangerState &&
                    this.paysResidenceState &&
                        (
                            // Si Canada et, province autre ou nationalité !FR, et 15 ans de cotisations
                            (this.paysResidence.codePays == 'CA' && (this.provinceCanada == 'autre' || this.$store.nationalite != 'FR') && this.$store.quinzeAnneesCotisations == 1) ||
                            // Si Canada et province Quebec et nationalité FR et, ne dispose de la double nat, ou bien dispose de la double nat mais a cotisé 15 ans
                            (this.paysResidence.codePays == 'CA' && this.provinceCanada == 'quebec' && this.$store.nationalite == 'FR' && (this.nationaliteFrCa == 'fr' || (this.nationaliteFrCa == 'fr-ca' && this.$store.quinzeAnneesCotisations == 1))) ||
                            // Si Bosnie Herzegovine, Montenegro, Maroc, Tunisie, Kosovo, Macédoine et, pension multi origines et 15 ans de cotisations ou bien pas de pension multi origines
                            (['BA', 'ME', 'MA', 'TN', 'XK', 'MK'].indexOf(this.paysResidence.codePays) !== -1 && ((this.pensionMultiOrigines == 1 && this.$store.quinzeAnneesCotisations == 1) || this.pensionMultiOrigines == 0)) ||
                            // Si Polynésie Francaise, St pierre-et-Miquelon, Andorre, Serbie et, pas de pension multi origines
                            (['PF', 'PM', 'AD', 'RS'].indexOf(this.paysResidence.codePays) !== -1 && this.pensionMultiOrigines == 0) ||
                            // Si Nouvelle-Calédonie
                            (this.paysResidence.codePays == 'NC') ||
                            // Pour tous les autres pays, si 15 ans de cotisations
                            (['CA', 'BA', 'ME', 'MA', 'TN', 'XK', 'MK', 'PF', 'PM', 'AD', 'RS', 'NC'].indexOf(this.paysResidence.codePays) === -1 && this.$store.quinzeAnneesCotisations == 1)
                        )
                    ) ? true : false
        },

        // Lance la verification totale des champs saisis afin de savoir si la page est correctement remplie pour passer a l'étape suivante
        checkAll: function() {
            return (this.checkFirst &&
                    this.emailState &&
                    // Pas d'adresse tempo, ou une adresse tempo avec l'hote et l'adresse bien remplis
                    (this.adresseTempoFrance == 0 || (this.adresseTempoFrance == 1 && this.nomHoteAdresseFranceState != false && this.adresseFranceState && this.communeFranceState))
                    ) ? true : false
        },

        buttons: function() {
            return {
                routes: {
                    back: 'Identite',
                    next: 'RegulariteDeSejour'
                },
                next: this.$actions.getStepChecked('accueil') && this.$actions.getStepChecked('identite') && this.$actions.getStepChecked('coordonnees')
            }
        }
  },
  mounted() {

    // Renvoi vers l'URL du site
    if (this.$store.endOfInscription || !this.$actions.getStepChecked('accueil') || !this.$actions.getStepChecked('identite')) {
        window.location = this.$config.SITE
    }

    // Envoi un évenement onSetStepper pour mettre a jour l'étape
    this.$emit('onSetStepper', 'coordonnees');

    // Construit la liste des pays à présenter dans le menu déroulant paysResidence
    this.$axios
      .get(this.$config.API + '/pays', {
            headers: {
                'Authorization': this.$store.token
            }
        })
      .then(response => {
            this.listePaysResidence = [{
                value: {},
                text: 'Veuillez confirmer le pays de résidence'
            }]
            response.data.forEach(obj => {
                // Renseigne le texte a présenter dans le select, et la value ici sous forme riche avec un objet
                let item = { text: obj.nompays, value: { codePays: obj.codepays, nomPays: obj.nompays, ue: obj.ue, eee: obj.eee, schengen: obj.schengen, cnarefeEligible: obj.cnarefeeligible } }
                this.listePaysResidence.push(item)
            });
      });
  },
  methods: {

    // Methodes du MenuListe pour l'adresse à l'étranger
    tappingAdresseEtranger() {
        this.$refs.menuListe.search();
    },
    focusingAdresseEtranger() {
        if (this.adresseEtranger != null && this.adresseEtranger.length > 0) {
            this.$refs.menuListe.show();
        } else {
            this.$refs.menuListe.hide();
        }
    },
    bluringAdresseEtranger() {
        this.$refs.menuListe.hide();
        this.adresseEtrangerState = (this.adresseEtranger != null && this.adresseEtranger != '') ? true : false;
    },
    getAdressesEtranger() {
        this.$axios
            .get(this.$config.API_NOMINATIM, {
                params: {
                    q: this.adresseEtranger,
                    addressdetails: 1,
                    format: 'geocodejson',
                    limit: 10
                }
            }).then(res => {
                this.adressesEtranger = [];
                for (let i in res.data.features) {
                    let geocoding = res.data.features[i].properties.geocoding;
                    this.adressesEtranger.push( { text: geocoding.label, value: geocoding.country } );
                }
                // Affiche le MenuListe avec les résultats ou rien, selon la réponse obtenue
                if (this.adressesEtranger.length > 0) {
                    this.$refs.menuListe.show();
                } else {
                    this.$refs.menuListe.hide();
                }
            }).catch(function(e) {
                console.log("Error: " + e)
            })
    },
    setAdresseEtranger(elt) {
        this.adresseEtranger = elt.text;
        // Memorise aussi le nom du pays (utile pour tester ensuite si les 2 pays sont identiques)
        this.paysEtranger = elt.value;
        this.$refs.menuListe.hide();
    },
    // Tente de rechercher l'item dans le select qui correspond au pays étranger choisi pour le selectionner automatiquement
    selectedPaysResidence(elt) {
        this.paysResidence = {};
        this.listePaysResidence.forEach(obj => {
            // Affecte la valeur du select lorsque le nom du pays de adresseEtranger (elt.value) correspond a un nom de pays présent dans listePaysResidence
            if (elt.value == obj.text) {
                this.paysResidence = obj.value;
                return;
            }
        });
    },
    // -- Fin Methodes du MenuListe

    // Methodes du MenuListe pour l'adresse en France
    tappingAdresseFrance() {
        this.$refs.menuListe1.search();
    },
    focusingAdresseFrance() {
        if (this.adresseFrance != null && this.adresseFrance.length > 0) {
            this.$refs.menuListe1.show();
        } else {
            this.$refs.menuListe1.hide();
        }
    },
    bluringAdresseFrance() {
        this.$refs.menuListe1.hide();
        this.adresseFranceState = (this.adresseFrance != null && this.adresseFrance != '') ? true : false;
    },
    getAdressesFrance() {
        this.$axios
            .get(this.$config.API_NOMINATIM, {
                params: {
                    q: this.adresseFrance,
                    addressdetails: 1,
                    format: 'geocodejson',
                    // Force la recherche en France uniquement
                    countrycodes: 'fr',
                    limit: 10
                }
            }).then(res => {
                this.adressesFrance = [];
                for (let i in res.data.features) {
                    //console.log(res.data.features[i].properties.geocoding)
                    let geocoding = res.data.features[i].properties.geocoding;
                    this.adressesFrance.push( { text: geocoding.label, value: geocoding.country, data: geocoding } );
                }
                // Affiche le MenuListe avec les résultats ou rien, selon la réponse obtenue
                if (this.adressesFrance.length > 0) {
                    this.$refs.menuListe1.show();
                } else {
                    this.$refs.menuListe1.hide();
                }
            }).catch(function(e) {
                console.log("Error: " + e)
            })
    },
    setAdresseFrance(elt) {
        this.adresseFrance = elt.text;
        this.$refs.menuListe1.hide();

        // IMPOSSIBLE D'ALIMENTER CORRECTEMENT LE CHAMP commune A CAUSE DES NOMS DES VILLES QUI NE SONT JAMAIS A LA MEME PLACE !!! A REVOIR... //

        // console.log(elt.data)
        // // Si un name et un code postal existent, alors on complète le champ de la commune avec ces données
        // if ((elt.data.locality || elt.data.name || elt.data.city) && elt.data.postcode) {
        //     var name = null;
        //     if (elt.data.locality) {
        //         name = elt.data.locality
        //     } else if (elt.data.name) {
        //         name = elt.data.name
        //     } else if (elt.data.city) {
        //         name = elt.data.city
        //     }
        //     let commune = name.toUpperCase() + ' (' + elt.data.postcode + ')';
        //     this.communeFrance = commune;
        //     this.communesFrance = [{ text: commune, value: commune }];
        // }
    },
    // -- Fin Methodes du MenuListe

    // Methodes du MenuListe pour la commune en France
    tappingCommuneFrance() {
        this.$refs.menuListe2.search();
    },
    focusingCommuneFrance() {
        if (this.communeFrance != null && this.communeFrance.length > 0) {
            this.$refs.menuListe2.show();
        } else {
            this.$refs.menuListe2.hide();
        }
    },
    bluringCommuneFrance() {
        this.$refs.menuListe2.hide();
        this.communeFranceState = (this.communeFrance != null && this.communeFrance != '') ? true : false;
    },
    getCommunesFrance() {
        // Si moins de de 3 charactères, on ne fait pas d'appel API
        if (this.communeFrance.length < 3) {
            return false;
        }
        this.$axios
            .get(this.$config.API + '/communes-france/' + this.communeFrance, {
                headers: {
                    'Authorization': this.$store.token
                }
            })
            .then(res => {
                this.communesFrance = [];
                for (let i in res.data) {
                    //console.log(res.data.features[i].properties.geocoding)
                    let commune = res.data[i];
                    commune = commune.ville_nom + ' (' + commune.ville_code_postal + ')';
                    this.communesFrance.push( { text: commune, value: commune } );
                }
                // Affiche le MenuListe avec les résultats ou rien, selon la réponse obtenue
                if (this.communesFrance.length > 0) {
                    this.$refs.menuListe2.show();
                } else {
                    this.$refs.menuListe2.hide();
                }
            }).catch(function(e) {
                console.log("Error: " + e)
            })
    },
    setCommuneFrance(elt) {
        this.communeFrance = elt.text;
        this.$refs.menuListe2.hide();
    },
    // -- Fin Methodes du MenuListe


    // Met en forme les nom/prenom en majuscule
    upperCase(value) {
        return value.toUpperCase()
    },

    // test si le pays de résidence est hors UE/EEE, Suisse, Royaume-Uni, Monaco et Mayotte ...
    isCnarefeEligible() {
        return (this.paysResidence.cnarefeEligible) ? true : false;
    }

  },
  watch: {
    adresseEtranger: function() {
        // Lit la variable show du composant enfant menuListe
        if (this.$refs.menuListe.$data.states.show) {
            this.getAdressesEtranger();
        }

        // Init certaines variables
        this.provinceCanada = null
        this.$store.quinzeAnneesCotisations = null
        this.nationaliteFrCa = null
        this.pensionMultiOrigines = null
    },
    paysResidence: function() {
        this.paysResidenceState = (Object.keys(this.paysResidence).length > 0) ? true : false;

        // Init certaines variables
        this.provinceCanada = null
        this.$store.quinzeAnneesCotisations = null
        this.nationaliteFrCa = null
        this.pensionMultiOrigines = null
    },
    provinceCanada: function() {
        this.provinceCanadaState = (this.provinceCanada) ? true : false

        // Init certaines variables
        this.$store.quinzeAnneesCotisations = null
        this.nationaliteFrCa = null
        this.pensionMultiOrigines = null
    },
    nationaliteFrCa: function() {
        this.nationaliteFrCaState = (this.nationaliteFrCa) ? true : false
        this.$store.quinzeAnneesCotisations = null
    },
    pensionMultiOrigines: function() {
        this.pensionMultiOriginesState = (this.pensionMultiOrigines != null) ? true : false
        this.$store.quinzeAnneesCotisations = null
    },
    email: function() {
        this.emailState = (this.email.match(/^[A-Z0-9_\-\.]+@[A-Z0-9_\-\.]+\.[A-Z]+$/gi)) ? true : false;
    },
    adresseTempoFrance: function() {
        this.nomHoteAdresseFrance = '';
        this.nomHoteAdresseFranceState = null;
        this.adresseFrance = null;
        this.adresseFranceState = null;
        this.communeFrance = null;
        this.communeFranceState = null;
    },
    nomHoteAdresseFrance: function() {
        this.nomHoteAdresseFranceState = (this.nomHoteAdresseFrance == '' || (this.nomHoteAdresseFrance != '' && this.$actions.controlName(this.nomHoteAdresseFrance))) ? true : false
    },
    adresseFrance: function() {
        // Lit la variable show du composant enfant menuListe
        if (this.$refs.menuListe1.$data.states.show) {
            this.getAdressesFrance();
        }
    },
    communeFrance: function() {
        // Lit la variable show du composant enfant menuListe
        if (this.$refs.menuListe2.$data.states.show) {
            this.getCommunesFrance();
        }
    },
    // Set l'état de controle général de la page dès lors que checkAll changera d'état
    checkAll: function(val) {
        this.$actions.setStepChecked('coordonnees', val);
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Coordonnees.vue